// extracted by mini-css-extract-plugin
module.exports = {"Icon":"styles_Icon__c7N8u","alignText":"styles_alignText__KDYqc","menu":"styles_menu__FwvwD"};